import app from '../firebase';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { useEffect, useState } from 'react';

export default function SearchEngine() {

    // variables for search
    const [keywords, setKeywords] = useState();
    const [category, setCategory] = useState();

    // categories
    const [productCategories, setProductCategories]     = useState();
    const [propertyCategories, setPropertyCategories]   = useState();
    const [serviceCategories, setServiceCategories]     = useState();

    const search = () => {
        if (category && keywords) {
            localStorage.setItem('search_bullet', JSON.stringify({ category, keywords })); // keywords in array form
            window.location.replace('/search');
        } else alert('Please select a category and put keywords!');
        
        return;
    }

    const getProductCategories = async () => {
        let x = [];

        await getDocs(collection(getFirestore(app), 'product_categories'))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        
        setProductCategories(x);
    }

    const getPropertyCategories = async () => {
        let x = [];
        
        await getDocs(collection(getFirestore(app), 'property_categories'))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        
        setPropertyCategories(x);
    }

    const getServiceCategories = async () => {
        let x = [];
        
        await getDocs(collection(getFirestore(app), 'service_categories'))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        
        setServiceCategories(x);
    }

    useEffect(() => {
        getProductCategories();
        getPropertyCategories();
        getServiceCategories();
    }, []);

    return(
        <>
            <div className="container-fluid d-none d-md-flex align-items-center justify-content-between bg-light p-4 px-5">
                <select className="form-select rounded-pill mx-4" style={{ width: '40%' }} onChange={data => setCategory(data.target.value)}>
                    <option value="" selected disabled>Category List</option>

                    <option value="" disabled>Product category</option>
                    { productCategories && productCategories.map(i => <option value={i[1].name}>{i[1].name}</option>) }

                    <option value="" disabled>Property Categories</option>
                    { propertyCategories && propertyCategories.map(i => <option value={i[1].name}>{i[1].name}</option>) }

                    <option value="" disabled>Service Categories</option>
                    { serviceCategories && serviceCategories.map(i => <option value={i[1].name}>{i[1].name}</option>) }
                </select>

                <input
                    type="text"
                    className="form-control rounded-pill mx-4"
                    placeholder="Search products/properties/services"
                    onChange={data => setKeywords(data.target.value.toLowerCase().split(' '))}
                />
                
                <button className="btn btn-dark rounded-circle" onClick={search}><i className="bi-search"></i></button>
            </div>
        </>
    );
}